(function(){
    'use strict';
    angular.module('mso.registration').factory('RegisterCompleteService', RegisterCompleteService);
    RegisterCompleteService.$inject = ['$resource', '$q', 'Config'];
    function RegisterCompleteService($resource, $q, Config){
        var umUserApi = $resource(Config.umBaseApiHrefV2 + "/registration/complete");
        var umUserQuestionApi = $resource(Config.umBaseApiHrefV2 + "/registration/question");
        var umBlackListApi = $resource(Config.umBaseApiHref + "/registration/blacklist", null, {
            'get': {method: 'GET', isArray: true}});

        return {
            getSecurityQuestion: getSecurityQuestion,
            prepareRegistrationDetails: prepareRegistrationDetails,
            completeRegistration: completeRegistration,
            getPasswordBlackList: getPasswordBlackList
        };

        function getSecurityQuestion(tokenId){
            var deferred = $q.defer();
            umUserQuestionApi.get({tokenId:tokenId}).$promise.then(function(data){
                deferred.resolve(data);
            }, function(data){
                deferred.reject(data);
            });
            return deferred.promise;
        }

        function getPasswordBlackList(){
            var deferred = $q.defer();
            umBlackListApi.get().$promise.then(function(data){
                deferred.resolve(data);
            }, function(error){
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function prepareRegistrationDetails (vm){
                var registrationDetails = {};
                registrationDetails.userName = vm.userName;
                registrationDetails.emailAddress = vm.emailAddress;
                registrationDetails.securityQuestionId = vm.securityQuestionId;
                registrationDetails.securityAnswer = vm.securityAnswer;
                registrationDetails.password = vm.password;
                registrationDetails.token = vm.tokenId;
                registrationDetails.ZxcvbnPayload = {
                    uiScore: vm.passwordStrength,
                    uiMatchPatterns: vm.passwordMatchPatterns
                };
                if (!vm.hasSecurityQuestions){
                    registrationDetails.securityQuestions = prepareSecurityQuestions(vm);
                }
                return registrationDetails;
        }

        function completeRegistration(details){
            var deferred = $q.defer();
            umUserApi.save(details).$promise.then(function(data){
                deferred.resolve(data);
            }, function(response){
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function prepareSecurityQuestions(vm) {
            var securityQuestions = [];
            angular.forEach(vm.securityQuestions, function (question) {
                securityQuestions.push({ 'id': question.securityQuestion, 'value': question.securityAnswer })
            });
            return securityQuestions;
        }
    }
})();